import { useParams } from 'react-router-dom'
import { setNavLink, unsetNavLink } from '../../actions/nav'
import { fetchStatusSummary } from '../../actions/status'
import StudentDetails from '../../components/students/coordinator/StudentDetails'
import StudentChangeLog from '../../components/students/coordinator/StudentChangeLog'
import { isFeatureEnabled } from '../../selectors/features'
import { isEmpty } from '../../utils/common'

const mapStateToProps = state => {
  const {
    status: { data: status },
    settingsEducationPeriod: { selectedEducationPeriod },
    user: {
      data: { selectedOrgId },
    },
  } = state
  return {
    selectedOrgId,
    selectedEducationPeriod,
    status,
    statusPanelEnabled: isFeatureEnabled(state, 'STATUS_PANEL'),
  }
}

const StudentDetailsPage = ({
  setNavLink,
  unsetNavLink,
  selectedOrgId,
  selectedEducationPeriod,
  status,
  statusPanelEnabled,
  fetchStatusSummary,
}) => {
  const { studentId } = useParams()

  useEffect(() => {
    setNavLink('/students', 'Back to Students')
    // need order status, only fetch if hasn't data doesn't exist
    if (statusPanelEnabled && isEmpty(status)) {
      fetchStatusSummary(selectedOrgId, selectedEducationPeriod)
    }

    return () => unsetNavLink()
  }, [status, selectedOrgId, selectedEducationPeriod, statusPanelEnabled])

  return (
    <CSSTransition
      classNames="animate-fade"
      in={true}
      timeout={500}
      appear={true}
      enter={false}
      exit={false}
    >
      <div className="container">
        <StudentDetails studentId={studentId} />
        <StudentChangeLog studentId={studentId} />
      </div>
    </CSSTransition>
  )
}

export default connect(mapStateToProps, {
  setNavLink,
  unsetNavLink,
  fetchStatusSummary,
})(StudentDetailsPage)
